import React from 'react';

class AppLogoComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            hover: false
        };

        this.toggleHover = this.toggleHover.bind(this);
    }

    toggleHover(e) {
        if(this) {
            this.setState(
                {
                    hover: !this.state.hover
                }
            );
            console.log("toggleHover()");
        }
        e.stopPropagation();
    }

    render() {

        var currStyle = this.props.style.normal;
        if(this.state.hover) currStyle = this.props.style.hover;

        return (

            <img src={this.props.logoImg} style={currStyle} onClick={this.props.onClickCallback}
                   onMouseOver={(e) => this.toggleHover(e)}
                   onMouseOut={(e) => this.toggleHover(e)}
            />
        );
    }
}

export default AppLogoComponent



// WEBPACK FOOTER //
// src/components/AppLogoComponent.js